import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }       from '@ngx-translate/core';

import { ApiService }              from '../../api/api.service';
import { CodeTypeModel }           from '../../core/models/code-type';
import { CustomerModel }           from '../../customers/models/customer';
import { MessagesService }         from '../../messages/messages.service';
import { MessengerService }        from '../../messages/messenger/messenger.service';
import { Table }                   from '../../table/types/table';
import { TemplatedWordingService } from '../../templates/templated-wording.service';
import { TemplateModel }           from '../../templates/typings/template';
import { ValidationsService }      from '../../sessions/validations.service';

@Component({
  selector   : 'wor-send-bulk-sms',
  template: require('./transaction-center.jobs.send-bulk-sms.component.html')
})
export class SendBulkSmsComponent implements OnInit {
  @Input() constraints: Array<CodeTypeModel>;
  @Input() statusTypes: Array<CodeTypeModel>;
  @Input() messageSettings: any;

  allSelected = false;
  customers: Array<CustomerModel>;
  isFlipped = false;
  loading = false;
  selectedItems: Array<CustomerModel> = [];
  smsMessage: string;
  tableSettings: Table;

  filters = {
    endDate    : '*',
    invoiceType: '*',
    jobStatus  : '*',
    startDate  : '*'
  };

  constructor (
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private messagesService: MessagesService,
    private messengerService: MessengerService,
    private templatedWording: TemplatedWordingService,
    private translateService: TranslateService,
    private validationsService: ValidationsService
  ) {}

  ngOnInit (): void {


    this.smsMessage = this.messageSettings?.default_bulk_sms_message || '';


  }

  addTemplates (): void {
    this.templatedWording.addTemplate('sms')
      .then((templates: Array<TemplateModel>) => {
        templates.forEach(template => {
          this.smsMessage = this.smsMessage
            ? `${this.smsMessage}\n\n${template.wording}`
            : template.wording;
        });
      });
  }

  onRowClick (): void {


    this.selectedItems = this.customers.filter(customer => customer.selected);


    this.allSelected = this.selectedItems.length === this.customers?.length;


  }

  search (): void {
    this.loading = true;

    this.apiService.get('/customers/customer_list_for_bulk_sms', [
      this.filters.startDate,
      this.filters.endDate,
      this.filters.invoiceType,
      this.filters.jobStatus
    ])
    .then((customers: Array<CustomerModel> = []) => {
      this.customers = customers;

      if (this.customers.length) {
        this.tableSettings = {
          columns: [
            { field: 'display_name', header: { text: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER') } },
            { field: 'mobile', header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.MOBILE') } },
            { field: 'job_card_number', header: { text: this.translateService.instant('INVOICE_SPACE.JOB_CARD_NUMBER') } },
            { field: 'job_status_comment', header: { text: this.translateService.instant('INVOICE_SPACE.JOB_STATUS_COMMENT') } }
          ],
          empty: { text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND') },
          pagination: { enabled: false },
          rows: {
            highlight: { enabled: true },
            select: { enabled: true, multi: true }
          },
          sorting: { enabled: false },
          static: true
        };

        this.selectedItems = [];
        this.isFlipped = true;
      } else {
        this.messagesService.show(this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND'), 'error');
        this.activeModal.close();
      }
    })
    .finally(() => {
      this.loading = false;
    });
  }

  selectAll (): void {
    this.allSelected = !this.allSelected;

    this.customers.forEach(customer => {
      customer.selected = this.allSelected;
    });

    this.selectedItems = this.customers.filter(customer => customer.selected);
  }

  sendSms (): void {
    const customers = [];

    this.selectedItems.forEach((customer: CustomerModel) => {
      const isMobileValid = this.validationsService.isPhoneNumberValid(customer.mobile, true);
      const firstName = customer.customer_type === 'C'
        ? (customer.contact_first || customer.contact1_first || customer.contact2_first || customer.company_name)
        : customer.first_name;

      customers.push({
        first_name: firstName,
        name      : customer.display_name,
        phone     : customer.mobile,
        valid     : isMobileValid ? 'yes' : 'no'
      });
    });

    this.messengerService.sendBulkSms(customers, this.smsMessage)
      .then(() => {
        this.messagesService.show(this.translateService.instant('GENERAL_SPACE.MESSAGE.BULK_SMS_SENT'), 'success');
        this.activeModal.close();
      })
      .catch(err => {
        this.messagesService.error(err);
      });
  }
}
